import { useNavigate } from "react-router-dom";
import { baseURL } from "../../../../constants/commonConstants";
import { ROUTER_URL } from "../../../../constants/routerUrl";
import { connect, useDispatch } from "react-redux";
import { useEffect } from "react";
import { IPowerBiReports } from "../../../../models/dashboard/staffDashboard";
import { limit, pageBlockId } from "../../../../constants/pageBlocks";
import { setReports } from "../../../../store/slices/master/reportSlice";
import { getReports } from "../../../../action/masters/reportActionCreator";
import { getPageBlockData } from "../../../../common-functions/commonFunctions";

const PowerBiResult = (props: IPowerBiReports) => {
  const { getReportResources, reportResources, snapShots } = props;
  const navigate = useNavigate();

  const handleViewAll = () => {
    navigate(ROUTER_URL.STAFF_REPORTS);
  };

  const pageBlockData = getPageBlockData(
    snapShots,
    pageBlockId.reportResources
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (pageBlockData?.displayOrNot) {
      getReportResources(pageBlockId.reportResources, limit.three);
    }
  }, [pageBlockData]);

  useEffect(() => {
    return () => {
      dispatch(setReports([]));
    };
  }, []);

  return (
    <>
      <div
        className={
          pageBlockData?.displayOrNot ? "card-wrap" : "card-wrap card-snapshot"
        }
        style={
          pageBlockData?.displayOrNot === false
            ? { backgroundImage: `url(${baseURL + pageBlockData.image})` }
            : {}
        }
      >
        <div className="title">
          <h2>Your Power BI Reports</h2>
          <a
            onClick={handleViewAll}
            className={
              pageBlockData?.displayOrNot ? "btn-link" : "btn-link d-none"
            }
            title="View All Reports"
          >
            View All
          </a>
        </div>
        <div className="mt-3 row stud-dash-apps dash-report">
          {reportResources?.map((report) => (
            <div className="col-lg-4">
              <div className="appcard">
                <a href={report.url} target="_blank">
                  <img src={baseURL + report.icon} alt="" />
                  <h3>{report.name}</h3>
                  <span>
                    <img src="/assets/images/icon/arrow-right.svg" alt="" />
                  </span>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getReportResources: (pageBlockId: number, noOfItems: number) =>
    getReports(undefined, pageBlockId, noOfItems, undefined),
};

function mapStateToProps(state: any) {
  return {
    reportResources: state.report.reports,
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PowerBiResult);
